import { Component, input } from '@angular/core';
import { SharedModule } from '@app/modules/shared.module';
import { MomentVie } from '@app/models/carnet-liaison';

@Component({
  selector: 'app-carnet-moment-de-vie',
  templateUrl: './carnet-moment-de-vie.component.html',
  styleUrl: './carnet-moment-de-vie.component.scss',
  standalone: true,
  imports: [SharedModule],
})
export class CarnetMomentDeVieComponent {
  data = input.required<MomentVie>();
}
